import QuotationMarks from '@desoutter/uikit/src/components/atoms/QuotationMarks'
import { ReassuranceTestimonialsCardFragment } from './ReassuranceTestimonialsCard.generated'
import { Image as DatoImage } from 'react-datocms'
import { cn } from '@desoutter/uikit'

type ReassuranceTestimonialsCardProps = {
	fragment: ReassuranceTestimonialsCardFragment
	isDark: boolean
	showAuthor?: boolean
}

export default function ReassuranceTestimonialsCard({
	fragment,
	isDark,
	showAuthor,
}: ReassuranceTestimonialsCardProps) {
	return (
		<div
			key={fragment.id}
			className={cn(
				'flex flex-col w-full justify-between bg-background text-foreground p-6 md:p-12 rounded-2xl animate-fadeIn gap-8',
			)}
		>
			<p className="text-md md:text-lg italic w-full">
				<QuotationMarks className="text-gray-300 dark:text-gray-600 fill-current float-left mr-1" />
				{fragment.text}
			</p>
			{showAuthor && (
				<div className="flex flex-col md:flex-row w-full items-start md:items-center justify-between gap-4">
					<div className="flex items-center gap-4 h-full w-full md:w-2/3">
						{fragment.authorAvatar?.responsiveImage && (
							<div className="flex items-center w-24 h-24">
								<DatoImage
									data={fragment.authorAvatar.responsiveImage}
									className="rounded-full"
								/>
							</div>
						)}
						<div className="flex flex-col gap-2">
							<h3 className="mb-0 text-md md:text-lg">
								{fragment.authorFirstname + ' ' + fragment.authorLastname}
							</h3>
							<p className="text-sm">{fragment.authorJob}</p>
						</div>
					</div>

					{fragment.companyLogoDark && (
						<div className="w-fit md:w-1/3">
							<DatoImage
								data={
									isDark
										? fragment.companyLogoDark.responsiveImage
										: fragment.companyLogoLight.responsiveImage
								}
								className={cn('max-h-16')}
								layout="responsive"
								objectFit="contain"
							/>
						</div>
					)}
				</div>
			)}
		</div>
	)
}
